'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgNotification(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M3.582 11.872h2.113C5.73 12.94 6.65 14 8.035 14c1.378 0 2.297-1.039 2.347-2.128h2.113c.665 0 1.082-.38 1.082-.945 0-.63-.53-1.154-1.053-1.634-.382-.344-.495-1.01-.566-1.805-.085-2.164-.735-3.625-2.184-4.177C9.526 2.566 8.89 2 8.034 2c-.847 0-1.49.566-1.73 1.311-1.45.552-2.1 2.013-2.185 4.177-.078.795-.184 1.461-.566 1.805-.53.48-1.053 1.003-1.053 1.634 0 .566.41.945 1.082.945zm.487-1.287v-.055c.197-.116.502-.322.757-.578.335-.334.546-1.767.59-2.625.058-1.922.778-2.762 1.637-2.957.131-.024.204-.08.211-.213.03-.474.335-.772.8-.772.474 0 .78.298.801.772.015.134.088.189.211.213.867.195 1.58 1.035 1.638 2.957.044.858.27 2.29.597 2.625.247.256.531.462.735.578v.055H4.069zm3.97 2.307c-.566 0-.975-.4-1.016-1.015h2.03c-.026.608-.442 1.015-1.015 1.015z", fill: "currentColor" }))));
}

module.exports = SvgNotification;
//# sourceMappingURL=Notification.js.map
